import { type ReactNode } from "react";
import { Link } from "wouter";
import { cn } from "@/lib/utils";

interface LexiconTileProps {
  mark: ReactNode;
  label: string;
  bgColor: string;
  textColor?: string;
  shape?: "square" | "arch" | "circle";
  href: string;
}

export function LexiconTile({
  mark,
  label,
  bgColor,
  textColor = "#ECE9E0",
  shape = "square",
  href,
}: LexiconTileProps) {
  const isCircle = shape === "circle";

  return (
    <Link
      href={href}
      className={cn(
        "cursor-pointer p-8 aspect-square flex flex-col items-center justify-center text-center group transition-all",
        shape === "arch" && "arch-crop",
        isCircle
          ? "rounded-full border border-[#293129] hover:bg-[#ECE9E0] hover:shadow-xl"
          : "hover:bg-[#293129] transition-colors"
      )}
      style={{
        backgroundColor: isCircle ? "transparent" : bgColor,
        color: isCircle ? "#293129" : textColor,
      }}
    >
      <div className="mb-6 opacity-80 group-hover:opacity-100 transition-opacity">
        {mark}
      </div>
      <span className="text-[9px] tracking-[0.2em] uppercase font-bold opacity-50">
        {label}
      </span>
    </Link>
  );
}
